import React from 'react';
import { DynamicModuleLoader } from 'redux-dynamic-modules';
import { getModule } from './module';
export var ReduxInitLoadable = function () { return (React.createElement(DynamicModuleLoader, { modules: [getModule()] })); };
ReduxInitLoadable.displayName = 'NftReduxLoadable';
export default ReduxInitLoadable;
//# sourceMappingURL=ModuleLoadable.js.map